<button
  mat-icon-button
  disableRipple
  routerLink="welcome"
  queryParamsHandling="preserve"
  id="back-btn"
>
  <mat-icon>arrow_back</mat-icon>
</button>
